import { render } from "./LikeButton.vue?vue&type=template&id=7e8171a8&scoped=true"
import script from "./LikeButton.vue?vue&type=script&lang=js"
export * from "./LikeButton.vue?vue&type=script&lang=js"

import "./LikeButton.vue?vue&type=style&index=0&id=7e8171a8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8171a8"]])

export default __exports__